import { Directive } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { ClientDataStoreService } from '@app/services/client-data-store.service';

export class ClientTree {
  Id: string;
  Name: string;
  LogoIconImageUrl: string;
  Clients: ClientTree[];
  Expanded: boolean;
  
  constructor() {
    this.Expanded = false;
  }
  
  public deserialize(input: any) {
    if (typeof input === 'undefined' || input === null) {
      return this;
    }
    
    Object.keys(input)
    .forEach(key => {
      if (typeof input[key] !== 'undefined') {
        this[key] = input[key];
      }
    });
    
    return this;
  }
}

@Directive()
export class ClientSelectDropdown {
  mainClient: ClientTree;
  selectedClient: ClientTree;
  currentLeafClientId: string;
  
  clientDropdownExpanded: boolean = false;
  
  selectClientSubscription: Subscription;
  subscriptions$: Subscription[] = [];
  
  constructor(
    private clientStore: ClientDataStoreService,
    protected router: Router
  ) {
    this.subscriptions$.push(
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => this.syncSelectedClient())
    );
  }

  get isInsightsRoute(): boolean {
    return this.router.url.split('?')[0].startsWith('/insights');
  }
  
  selectClient(client: ClientTree) {
    this.selectedClient = client;

    if (this.isInsightsRoute) {
      this.persistLeafClientSelection(client);

      const urlTree = this.router.parseUrl(this.router.url);
      urlTree.queryParams = { ...urlTree.queryParams, clientId: client.Id };
      this.router.navigateByUrl(urlTree);
      return;
    }

    this.persistLeafClientSelection(client);
  }

  private persistLeafClientSelection(client: ClientTree) {
    if (client.Clients.length > 0) {
      return;
    }

    localStorage.setItem('selectedClient', client.Id);

    this.selectClientSubscription?.unsubscribe();
    this.selectClientSubscription = this.clientStore.selectClient(client.Id).subscribe();
  }

  syncSelectedClient(clientSummaryId?: string) {
    if (clientSummaryId) {
      this.currentLeafClientId = clientSummaryId;
    }

    if (!this.mainClient) {
      return;
    }

    const insightsClientId = this.router.parseUrl(this.router.url).queryParams.clientId;
    const selectedClientId = this.isInsightsRoute
      ? insightsClientId || this.mainClient.Id
      : this.currentLeafClientId || this.mainClient.Id;

    this.selectedClient = this.getClientFromTreeById(this.mainClient, selectedClientId) || this.mainClient;
  }

  onToggleClientChildren(event: Event, client: ClientTree) {
    event.stopPropagation();
    this.toggleClientChildren(client);
  }
  
  toggleClientChildren(client: ClientTree) {
    client.Expanded = !client.Expanded; 
  }
  
  getClientFromTreeById(clientTree: ClientTree, clientId, expandParent = false): ClientTree {
    if (!clientTree || !clientId) {
      return null;
    }

    if (clientTree.Id === clientId) {
      return clientTree;
    }
    
    for (let i = 0; i < clientTree.Clients.length; i++) {
      let client = this.getClientFromTreeById(clientTree.Clients[i], clientId);
      
      if (client) {
        if (expandParent) {
          clientTree.Expanded = true;
        }
        
        return client;
      }
    }

    return null;
  }
}
